module.exports = __webpack_public_path__ + "img/Pera-temporada.22f02d15.jpg";